module.exports = __webpack_public_path__ + "static/media/loading.cffa9d9d.gif";